var _rect, _path, _path2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestInRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#FDF2ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9804 14.1796C16.2123 14.4116 16.2123 14.7876 15.9804 15.0196C15.7484 15.2516 15.3724 15.2516 15.1404 15.0196L14.0004 13.8796V18.1996C14.0004 18.531 13.7318 18.7996 13.4004 18.7996C13.069 18.7996 12.8004 18.531 12.8004 18.1996V13.8796L11.6604 15.0196C11.4284 15.2516 11.0524 15.2516 10.8204 15.0196C10.5884 14.7876 10.5884 14.4116 10.8204 14.1796L13.4004 11.5996L15.9804 14.1796Z",
    fill: "#E87A46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50717 17.0526C9.36267 17.2759 9.06933 17.3482 8.83761 17.2176L6.5 15.9C6.2 15.7 6 15.4 6 15.05V8.95C6 8.6 6.2 8.25 6.5 8.1L11.5 5.15C11.65 5.05 11.8 5 12 5C12.2 5 12.35 5.05 12.5 5.15L17.5 8.1C17.8 8.3 18 8.6 18 8.95V11.5C18 11.7761 17.7761 12 17.5 12C17.2239 12 17 11.7761 17 11.5V8.95L12 6L7 8.95V15.05L9.3284 16.3389C9.58345 16.4801 9.66554 16.8078 9.50717 17.0526Z",
    fill: "#E87A46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#E87A46"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestInRounded);
export default __webpack_public_path__ + "static/media/RequestInRounded.d1361813662a8f84d53bfcd2992d6dbb.svg";
export { ForwardRef as ReactComponent };